var React = require('react');

function Forward (props) {
    return React.createElement("svg",props,React.createElement("polyline",{"points":"184 112 328 256 184 400","style":{"fill":"none","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"48px"}}));
}

Forward.defaultProps = {"viewBox":"0 0 512 512"};

module.exports = Forward;

Forward.default = Forward;
